<app-section #parentSection
             [title]="title"
             [dropdown]="false"
             [key]="key"
             [sectionRef]="section"
             [formGroup]="formGroup"
             [formConfig]="formConfig"
             class="additional-information-section">

    <ng-template #section>
        <div class="col additional-information-section__text-field-edits" *ngIf="vehicleTextFieldEditConfig">
            <div class="section__component"
                [ngClass]="{'col-50': !vehicleValueVisible, 'col-33': vehicleValueVisible}">
                <app-text-field-edit    [config]="vehicleTextFieldEditConfig"
                                        (onAction)="edit()">
                </app-text-field-edit>
            </div>
            <div class="section__component"
                 [ngClass]="{'col-50': !vehicleValueVisible, 'col-33': vehicleValueVisible}">
                <app-text-field-edit [config]="insurancePeriodTextFieldEditConfig"
                                     (onAction)="edit()">
                </app-text-field-edit>
            </div>
            <div *ngIf="vehicleValueVisible"
                 class="section__component col-33">
                <app-text-field-edit [config]="vehicleValueTextFieldEditConfig">
                </app-text-field-edit>
            </div>
        </div>

        <div class="col">
            <div *ngIf="isVisible(consts.VIN)" class="section__component col-50">
                <app-text-field [bean]="bean"
                                [errorsMap]="formFactoryService.errorsMap"
                                [control]="formGroup.controls[consts.VIN]"
                                [fieldConfig]="formFactoryService.fieldConfig(consts.VIN, formConfig)"
                                [context]="formConfig.formKey"
                                [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.VIN)]"
                                (markAsDirty)="markAsDirty($event)"
                                (changeEvent)="onFieldChange($event)"
                                (interactiveClick)="parentSection.sendCheckoutElementClickEvent($event)"
                >
                </app-text-field>
            </div>

            <div *ngIf="registrationNumberTextFieldEditConfig" class="section__component col-50">
                <app-text-field-edit    [config]="registrationNumberTextFieldEditConfig"
                                        (onAction)="edit()">
                </app-text-field-edit>
            </div>

            <div *ngIf="isVisible(consts.KEYS_AMOUNT)" class="section__component col-50">
                <app-select [bean]="bean"
                            [errorsMap]="formFactoryService.errorsMap"
                            [control]="formGroup.controls[consts.KEYS_AMOUNT]"
                            [fieldConfig]="formFactoryService.fieldConfig(consts.KEYS_AMOUNT, formConfig)"
                            [context]="formConfig.formKey"
                            (changeEvent)="onFieldChange($event)"
                            (interactiveClick)="parentSection.sendCheckoutElementClickEvent($event)"
                >
                </app-select>
            </div>

            <div *ngIf="isVisible(consts.ORIGINAL_KEYS_AMOUNT)" class="section__component col-50">
                <app-select [bean]="bean"
                            [errorsMap]="formFactoryService.errorsMap"
                            [control]="formGroup.controls[consts.ORIGINAL_KEYS_AMOUNT]"
                            [fieldConfig]="formFactoryService.fieldConfig(consts.ORIGINAL_KEYS_AMOUNT, formConfig)"
                            [context]="formConfig.formKey"
                            (changeEvent)="onFieldChange($event)"
                            (interactiveClick)="parentSection.sendCheckoutElementClickEvent($event)"
                >
                </app-select>
            </div>

            <div *ngIf="isVisible(consts.LEECHED_KEYS_AMOUNT)" class="section__component col-50">
                <app-select [bean]="bean"
                            [errorsMap]="formFactoryService.errorsMap"
                            [control]="formGroup.controls[consts.LEECHED_KEYS_AMOUNT]"
                            [fieldConfig]="formFactoryService.fieldConfig(consts.LEECHED_KEYS_AMOUNT, formConfig)"
                            [context]="formConfig.formKey"
                            (changeEvent)="onFieldChange($event)"
                            (interactiveClick)="parentSection.sendCheckoutElementClickEvent($event)"
                >
                </app-select>
            </div>

            <div *ngIf="isVisible(consts.TECHNICAL_INSPECTION_DATE)" class="section__component col-50">
                <app-material-datepicker [errorsMap]="formFactoryService.errorsMap"
                                         [control]="formGroup.controls[consts.TECHNICAL_INSPECTION_DATE]"
                                         [fieldConfig]="formFactoryService.fieldConfig(consts.TECHNICAL_INSPECTION_DATE, formConfig)"
                                         [context]="formConfig.formKey"
                                         [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.TECHNICAL_INSPECTION_DATE)]"
                                         (markAsDirty)="markAsDirty($event)"
                                         (changeEvent)="onFieldChange($event)"
                                         (interactiveClick)="parentSection.sendCheckoutElementClickEvent($event)"
                >
                </app-material-datepicker>
            </div>
        </div>

        <div class="col" [ngClass]="{'additional-information-section__button-toggles': isNext }">
            <div *ngIf="isVisible(consts.IMMOBILIZER)" class="section__component col-50">
                <app-radio *ngIf="isFieldTypeRadio(consts.IMMOBILIZER)"
                           [bean]="bean"
                           [errorsMap]="formFactoryService.errorsMap"
                           [control]="formGroup.controls[consts.IMMOBILIZER]"
                           [fieldConfig]="formFactoryService.fieldConfig(consts.IMMOBILIZER, formConfig)"
                           [context]="formConfig.formKey"
                           (changeEvent)="onFieldChange($event)"
                           (interactiveClick)="parentSection.sendCheckoutElementClickEvent($event)"
                >
                </app-radio>

                <app-button-toggle *ngIf="isFieldTypeButtonToggle(consts.IMMOBILIZER)"
                                   [bean]="bean"
                                   [errorsMap]="formFactoryService.errorsMap"
                                   [control]="formGroup.controls[consts.IMMOBILIZER]"
                                   [fieldConfig]="formFactoryService.fieldConfig(consts.IMMOBILIZER, formConfig)"
                                   [context]="formConfig.formKey"
                                   (changeEvent)="onFieldChange($event)"
                                   (interactiveClick)="parentSection.sendCheckoutElementClickEvent($event)"
                >
                </app-button-toggle>
            </div>

            <div *ngIf="isVisible(consts.MECHANIC_LOCK_TRANSMISSION)" class="section__component col-50">
                <app-radio *ngIf="isFieldTypeRadio(consts.MECHANIC_LOCK_TRANSMISSION)"
                           [bean]="bean"
                           [errorsMap]="formFactoryService.errorsMap"
                           [control]="formGroup.controls[consts.MECHANIC_LOCK_TRANSMISSION]"
                           [fieldConfig]="formFactoryService.fieldConfig(consts.MECHANIC_LOCK_TRANSMISSION, formConfig)"
                           [context]="formConfig.formKey"
                           (changeEvent)="onFieldChange($event)"
                           (interactiveClick)="parentSection.sendCheckoutElementClickEvent($event)"
                >
                </app-radio>

                <app-button-toggle *ngIf="isFieldTypeButtonToggle(consts.MECHANIC_LOCK_TRANSMISSION)"
                                   [bean]="bean"
                                   [errorsMap]="formFactoryService.errorsMap"
                                   [control]="formGroup.controls[consts.MECHANIC_LOCK_TRANSMISSION]"
                                   [fieldConfig]="formFactoryService.fieldConfig(consts.MECHANIC_LOCK_TRANSMISSION, formConfig)"
                                   [context]="formConfig.formKey"
                                   (changeEvent)="onFieldChange($event)"
                                   (interactiveClick)="parentSection.sendCheckoutElementClickEvent($event)"
                >
                </app-button-toggle>
            </div>

            <div *ngIf="isVisible(consts.AUTOALARM)" class="section__component col-50">
                <app-radio *ngIf="isFieldTypeRadio(consts.AUTOALARM)"
                           [bean]="bean"
                           [errorsMap]="formFactoryService.errorsMap"
                           [control]="formGroup.controls[consts.AUTOALARM]"
                           [fieldConfig]="formFactoryService.fieldConfig(consts.AUTOALARM, formConfig)"
                           [context]="formConfig.formKey"
                           (changeEvent)="onFieldChange($event)"
                           (interactiveClick)="parentSection.sendCheckoutElementClickEvent($event)"
                >
                </app-radio>

                <app-button-toggle *ngIf="isFieldTypeButtonToggle(consts.AUTOALARM)"
                                   [bean]="bean"
                                   [errorsMap]="formFactoryService.errorsMap"
                                   [control]="formGroup.controls[consts.AUTOALARM]"
                                   [fieldConfig]="formFactoryService.fieldConfig(consts.AUTOALARM, formConfig)"
                                   [context]="formConfig.formKey"
                                   (changeEvent)="onFieldChange($event)"
                                   (interactiveClick)="parentSection.sendCheckoutElementClickEvent($event)"
                >
                </app-button-toggle>
            </div>

            <div *ngIf="isVisible(consts.GPS)" class="section__component col-50">
                <app-radio *ngIf="isFieldTypeRadio(consts.GPS)"
                           [bean]="bean"
                           [errorsMap]="formFactoryService.errorsMap"
                           [control]="formGroup.controls[consts.GPS]"
                           [fieldConfig]="formFactoryService.fieldConfig(consts.GPS, formConfig)"
                           [context]="formConfig.formKey"
                           (changeEvent)="onFieldChange($event)"
                           (interactiveClick)="parentSection.sendCheckoutElementClickEvent($event)"
                >
                </app-radio>

                <app-button-toggle *ngIf="isFieldTypeButtonToggle(consts.GPS)"
                                   [bean]="bean"
                                   [errorsMap]="formFactoryService.errorsMap"
                                   [control]="formGroup.controls[consts.GPS]"
                                   [fieldConfig]="formFactoryService.fieldConfig(consts.GPS, formConfig)"
                                   [context]="formConfig.formKey"
                                   (changeEvent)="onFieldChange($event)"
                                   (interactiveClick)="parentSection.sendCheckoutElementClickEvent($event)"
                >
                </app-button-toggle>
            </div>

            <div *ngIf="isVisible(consts.USA_CANADA_REGISTRATION)" class="section__component col-50">
                <app-radio *ngIf="isFieldTypeRadio(consts.USA_CANADA_REGISTRATION)"
                           [bean]="bean"
                           [errorsMap]="formFactoryService.errorsMap"
                           [control]="formGroup.controls[consts.USA_CANADA_REGISTRATION]"
                           [fieldConfig]="formFactoryService.fieldConfig(consts.USA_CANADA_REGISTRATION, formConfig)"
                           [context]="formConfig.formKey"
                           (changeEvent)="onFieldChange($event)"
                           (interactiveClick)="parentSection.sendCheckoutElementClickEvent($event)"
                >
                </app-radio>

                <app-button-toggle *ngIf="isFieldTypeButtonToggle(consts.USA_CANADA_REGISTRATION)"
                                   [bean]="bean"
                                   [errorsMap]="formFactoryService.errorsMap"
                                   [control]="formGroup.controls[consts.USA_CANADA_REGISTRATION]"
                                   [fieldConfig]="formFactoryService.fieldConfig(consts.USA_CANADA_REGISTRATION, formConfig)"
                                   [context]="formConfig.formKey"
                                   (changeEvent)="onFieldChange($event)"
                                   (interactiveClick)="parentSection.sendCheckoutElementClickEvent($event)"
                >
                </app-button-toggle>
            </div>

            <div *ngIf="isVisible(consts.OTHER_SECURITIES)" class="section__component col-50">
                <app-radio *ngIf="isFieldTypeRadio(consts.OTHER_SECURITIES)"
                           [bean]="bean"
                           [errorsMap]="formFactoryService.errorsMap"
                           [control]="formGroup.controls[consts.OTHER_SECURITIES]"
                           [fieldConfig]="formFactoryService.fieldConfig(consts.OTHER_SECURITIES, formConfig)"
                           [context]="formConfig.formKey"
                           (changeEvent)="onFieldChange($event)"
                           (interactiveClick)="parentSection.sendCheckoutElementClickEvent($event)"
                >
                </app-radio>

                <app-button-toggle *ngIf="isFieldTypeButtonToggle(consts.OTHER_SECURITIES)"
                                   [bean]="bean"
                                   [errorsMap]="formFactoryService.errorsMap"
                                   [control]="formGroup.controls[consts.OTHER_SECURITIES]"
                                   [fieldConfig]="formFactoryService.fieldConfig(consts.OTHER_SECURITIES, formConfig)"
                                   [context]="formConfig.formKey"
                                   (changeEvent)="onFieldChange($event)"
                                   (interactiveClick)="parentSection.sendCheckoutElementClickEvent($event)"
                >
                </app-button-toggle>
            </div>
        </div>

    </ng-template>
</app-section>
